import {
  createCheckoutTemplate as publicCreateCheckoutTemplate,
  getCheckoutTemplate as publicGetCheckoutTemplate,
  updateCheckoutTemplate as publicUpdateCheckoutTemplate,
  deleteCheckoutTemplate as publicDeleteCheckoutTemplate,
  queryCheckoutTemplates as publicQueryCheckoutTemplates,
  createCheckoutFromTemplate as publicCreateCheckoutFromTemplate,
  createAndRedirectToCheckout as publicCreateAndRedirectToCheckout,
} from './ecom-v1-checkout-template-checkout-templates.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { onCheckoutTemplateCreated as publicOnCheckoutTemplateCreated } from './ecom-v1-checkout-template-checkout-templates.public.js';
import { onCheckoutTemplateDeleted as publicOnCheckoutTemplateDeleted } from './ecom-v1-checkout-template-checkout-templates.public.js';
import { onCheckoutTemplateUpdated as publicOnCheckoutTemplateUpdated } from './ecom-v1-checkout-template-checkout-templates.public.js';
import { onCheckoutTemplateUsed as publicOnCheckoutTemplateUsed } from './ecom-v1-checkout-template-checkout-templates.public.js';

export const createCheckoutTemplate: MaybeContext<
  BuildRESTFunction<typeof publicCreateCheckoutTemplate> &
    typeof publicCreateCheckoutTemplate
> = /*#__PURE__*/ createRESTModule(publicCreateCheckoutTemplate);
export const getCheckoutTemplate: MaybeContext<
  BuildRESTFunction<typeof publicGetCheckoutTemplate> &
    typeof publicGetCheckoutTemplate
> = /*#__PURE__*/ createRESTModule(publicGetCheckoutTemplate);
export const updateCheckoutTemplate: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCheckoutTemplate> &
    typeof publicUpdateCheckoutTemplate
> = /*#__PURE__*/ createRESTModule(publicUpdateCheckoutTemplate);
export const deleteCheckoutTemplate: MaybeContext<
  BuildRESTFunction<typeof publicDeleteCheckoutTemplate> &
    typeof publicDeleteCheckoutTemplate
> = /*#__PURE__*/ createRESTModule(publicDeleteCheckoutTemplate);
export const queryCheckoutTemplates: MaybeContext<
  BuildRESTFunction<typeof publicQueryCheckoutTemplates> &
    typeof publicQueryCheckoutTemplates
> = /*#__PURE__*/ createRESTModule(publicQueryCheckoutTemplates);
export const createCheckoutFromTemplate: MaybeContext<
  BuildRESTFunction<typeof publicCreateCheckoutFromTemplate> &
    typeof publicCreateCheckoutFromTemplate
> = /*#__PURE__*/ createRESTModule(publicCreateCheckoutFromTemplate);
export const createAndRedirectToCheckout: MaybeContext<
  BuildRESTFunction<typeof publicCreateAndRedirectToCheckout> &
    typeof publicCreateAndRedirectToCheckout
> = /*#__PURE__*/ createRESTModule(publicCreateAndRedirectToCheckout);
/** */
export const onCheckoutTemplateCreated: ReturnType<
  typeof createEventModule<typeof publicOnCheckoutTemplateCreated>
> = createEventModule(publicOnCheckoutTemplateCreated);
/** */
export const onCheckoutTemplateDeleted: ReturnType<
  typeof createEventModule<typeof publicOnCheckoutTemplateDeleted>
> = createEventModule(publicOnCheckoutTemplateDeleted);
/** */
export const onCheckoutTemplateUpdated: ReturnType<
  typeof createEventModule<typeof publicOnCheckoutTemplateUpdated>
> = createEventModule(publicOnCheckoutTemplateUpdated);
/** */
export const onCheckoutTemplateUsed: ReturnType<
  typeof createEventModule<typeof publicOnCheckoutTemplateUsed>
> = createEventModule(publicOnCheckoutTemplateUsed);

export {
  Status,
  DescriptionLineType,
  PaymentOptionType,
  ItemTypeItemType,
  SubscriptionFrequency,
  FileType,
  TaxableAddressType,
  JurisdictionType,
  ItemAvailabilityStatus,
  VatType,
  PickupMethod,
  ChargeType,
  RuleType,
  DiscountType,
  WeightUnit,
  RateType,
  ManualCalculationReason,
  FallbackReason,
  ChannelType,
  AdditionalFeeSource,
  Severity,
  NameInOther,
  NameInLineItem,
  SuggestedFix,
  SortOrder,
  WebhookIdentityType,
} from './ecom-v1-checkout-template-checkout-templates.universal.js';
export {
  CheckoutTemplate,
  CheckoutCustomization,
  WebClientCustomization,
  V1LineItem,
  CatalogReference,
  CatalogOverrideFields,
  ProductName,
  DescriptionLine,
  DescriptionLineValueOneOf,
  DescriptionLineDescriptionLineValueOneOf,
  DescriptionLineName,
  PlainTextValue,
  Color,
  PhysicalProperties,
  PaymentOption,
  CustomLineItem,
  PriceDescription,
  ItemType,
  ItemTypeItemTypeDataOneOf,
  SubscriptionOptionInfo,
  SubscriptionSettings,
  FreeTrialPeriod,
  Title,
  Description,
  SecuredMedia,
  ServiceProperties,
  Policy,
  TaxableAddress,
  TaxableAddressTaxableAddressDataOneOf,
  ExtendedFields,
  CustomContentReference,
  ExternalReference,
  CheckoutTemplateUsed,
  Checkout,
  LineItem,
  MultiCurrencyPrice,
  ItemTaxFullDetails,
  TaxRateBreakdown,
  TaxBreakdown,
  FocalPoint,
  ItemAvailabilityInfo,
  Scope,
  Group,
  AddressWithContact,
  Address,
  StreetAddress,
  AddressLocation,
  FullAddressContactDetails,
  VatId,
  ShippingInfo,
  SelectedCarrierServiceOption,
  DeliveryLogistics,
  PickupDetails,
  DeliveryTimeSlot,
  SelectedCarrierServiceOptionPrices,
  SelectedCarrierServiceOptionOtherCharge,
  DeliveryAllocation,
  Carrier,
  Region,
  ApplicableLineItems,
  ShippingRegion,
  CarrierServiceOption,
  ShippingOption,
  ShippingPrice,
  OtherCharge,
  BuyerInfo,
  BuyerInfoIdOneOf,
  PriceSummary,
  CalculationErrors,
  CalculationErrorsShippingCalculationErrorOneOf,
  Details,
  DetailsKindOneOf,
  ApplicationError,
  ValidationError,
  FieldViolation,
  SystemError,
  CarrierErrors,
  CarrierError,
  GiftCard,
  AppliedDiscount,
  AppliedDiscountDiscountSourceOneOf,
  Coupon,
  MerchantDiscount,
  DiscountRule,
  DiscountRuleName,
  LineItemDiscount,
  CustomField,
  TaxSummary,
  TaxCalculationDetails,
  TaxCalculationDetailsCalculationDetailsOneOf,
  AutoTaxFallbackCalculationDetails,
  AggregatedTaxBreakdown,
  CreatedBy,
  CreatedByIdOneOf,
  MembershipOptions,
  Membership,
  MembershipName,
  MembershipPaymentCredits,
  InvalidMembership,
  SelectedMemberships,
  SelectedMembership,
  AdditionalFee,
  ConversionInfo,
  Violation,
  Target,
  TargetTargetTypeOneOf,
  Other,
  TargetLineItem,
  CustomSettings,
  SubscriptionCharges,
  Charge,
  CreateCheckoutTemplateRequest,
  CreateCheckoutTemplateResponse,
  GetCheckoutTemplateRequest,
  GetCheckoutTemplateResponse,
  UpdateCheckoutTemplateRequest,
  UpdateCheckoutTemplateResponse,
  DeleteCheckoutTemplateRequest,
  DeleteCheckoutTemplateResponse,
  QueryCheckoutTemplatesRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryCheckoutTemplatesResponse,
  CursorPagingMetadata,
  Cursors,
  CreateCheckoutFromTemplateRequest,
  CreateCheckoutFromTemplateResponse,
  CreateAndRedirectToCheckoutRequest,
  RawHttpResponse,
  HeadersEntry,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  CheckoutTemplateNonNullableFields,
  CreateCheckoutTemplateResponseNonNullableFields,
  GetCheckoutTemplateResponseNonNullableFields,
  UpdateCheckoutTemplateResponseNonNullableFields,
  QueryCheckoutTemplatesResponseNonNullableFields,
  CreateCheckoutFromTemplateResponseNonNullableFields,
  RawHttpResponseNonNullableFields,
  BaseEventMetadata,
  EventMetadata,
  CheckoutTemplateCreatedEnvelope,
  CheckoutTemplateDeletedEnvelope,
  CheckoutTemplateUpdatedEnvelope,
  CheckoutTemplateUsedEnvelope,
  UpdateCheckoutTemplate,
  CheckoutTemplatesQueryResult,
  CheckoutTemplatesQueryBuilder,
} from './ecom-v1-checkout-template-checkout-templates.universal.js';
